import { useAddI18nLocales, useTranslation } from './i18n';

type TErrorBoundaryProps = {
  error: Error;
  reset: () => void;
};

// Modern.js injects error + reset when this component is used as an error boundary.
export const LearningDashboardErrorBoundary = ({
  error,
  reset,
}: TErrorBoundaryProps) => {
  useAddI18nLocales();
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-cds-py-8 tw-cds-gap-5">
      <p className="tw-cds-font-body-02 tw-cds-text-secondary">
        {t('ERROR_TITLE')}
      </p>
      <p className="tw-cds-font-body-01 tw-cds-text-tertiary">
        {error.message}
      </p>
      <button
        type="button"
        className="tw-cds-font-label-01 tw-cds-text-brand"
        onClick={reset}
      >
        {t('ERROR_RETRY')}
      </button>
    </div>
  );
};
